import { FC } from 'react';
import { Modal, ModalActions } from '@lambdacurry/component-library';
import { ModalWithActionsProps } from '../modals.types';

export const AlreadyInCartModal: FC<ModalWithActionsProps> = ({ actions, isOpen, onAfterClose, ...props }) => (
  <Modal className="already-in-cart-modal" isOpen={isOpen} onAfterClose={onAfterClose} {...props}>
    <h3>Just Checking...</h3>
    <p>This item is already in your box. Are you sure you'd like to add it again?</p>

    {actions && <ModalActions>{actions}</ModalActions>}
  </Modal>
);
